export enum IMPORT_DOMAIN {
  DRAFT_HISTORY = 'draftHistory',
}

export const IMPORT_DOMAIN_KEY = 'ruleImport';
